// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kmn2","option":"styles_option__2ojYp","active":"styles_active__2WnyH"};